export class Calendar {
    constructor(
      public body1: string,
      public body2: string,
      public body3: string,
      public body4: string,
      public date1: string,
      public date2: string,
      public date3: string,
      public date4: string,
      public tab1Date: string,
      public tab2Date: string,
      public tab3Date: string,
      public tab4Date: string,
      public title: string,
      public displayName: string,
      public id: string,
    ) {
    }
}
